import {Component, OnDestroy, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {Subject} from 'rxjs';
import {TranslationSupportiveLanguage, UpdateTranslationSettingsModel} from '../../../models/translation.model';
import {TranslationService} from '../../../services/translation.service';
import {TranslationSettingComponent} from '../translation-setting/translation-setting.component';
import { MatDialogRef } from '@angular/material/dialog';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {select, Store} from '@ngrx/store';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {takeUntil} from 'rxjs/operators';
import {QueryProvider} from '@shared/queries/query-provider';
import {TranslationStatus, TranslationToolNames} from '../../../models/translation.constants';

@Component({
    standalone: false,
    selector: 'particle-update-translation-setting',
  templateUrl: './update-translation-setting.component.html',
  styleUrls: ['./update-translation-setting.component.scss']
})
export class UpdateTranslationSettingComponent implements OnInit, IDialogView, OnDestroy {
  data: DialogModel;
  supportiveLanguageQueryKey = 'TranslationSupportiveLanguage';
  unsubscribe$ = new Subject<void>();
  fileToUpload: File;
  isFileScanned: boolean;
  toLanguage: string;
  fromLanguage: string;
  translationSupportiveLanguage: TranslationSupportiveLanguage[] = [];
  private language$: any;
  translationConfig: UpdateTranslationSettingsModel = new UpdateTranslationSettingsModel();
  originalConfig: UpdateTranslationSettingsModel = new UpdateTranslationSettingsModel();
  translationStatus = TranslationStatus;
  translationToolNames = TranslationToolNames;

  constructor(private translationService: TranslationService,
              public dialogRef: MatDialogRef<UpdateTranslationSettingComponent>,
              private queryStore: Store<IQueryState>) { }

  ngOnInit() {
    if (this.data.input.translationConfig) {
      this.translationConfig = this.data.input.translationConfig;
      this.originalConfig = JSON.parse(JSON.stringify(this.data.input.translationConfig));
    }
    this.language$ = this.queryStore.pipe(select(getQueryResponse, this.supportiveLanguageQueryKey), takeUntil(this.unsubscribe$));
    this.language$.subscribe(language => {
      if (language) {
        this.translationSupportiveLanguage = language;
        if (this.translationSupportiveLanguage && this.translationSupportiveLanguage.length > 0) {
          this.translationSupportiveLanguage = this.translationService.sortTranslationSupportiveLanguage(this.translationSupportiveLanguage);
        }
      }
    });
    QueryProvider.invokeQuery(this.queryStore, this.supportiveLanguageQueryKey, {});
  }

  onOkClicked(): boolean {
    this.data.input.translationConfig = this.translationConfig;
    return true;
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

 handleCheckbox() {
 }

}
